import React from 'react'

import { Route } from 'react-router'

import config from 'config/routes'
import { FullPage } from 'layouts/FullPage'

import { HowGoustoWorks, FoodBox, MealPlanning } from './MarketingPages'

export const HowGoustoFoodBoxesWorkPage = (
  <Route
    component={FullPage}
    props={{
      footerType: 'large',
      footerIsOnLandingPage: true,
    }}
  >
    <Route path={config.client.howGoustoWorks} component={HowGoustoWorks} />
  </Route>
)

export const MealPlanningPage = (
  <Route
    component={FullPage}
    props={{
      footerType: 'large',
      footerIsOnLandingPage: true,
    }}
  >
    <Route path={config.client.goustoMealPlanning} component={MealPlanning} />
  </Route>
)

export const FoodBoxPage = (
  <Route
    component={FullPage}
    props={{
      footerType: 'large',
      footerIsOnLandingPage: true,
    }}
  >
    <Route path={config.client.foodBox} component={FoodBox} />
  </Route>
)
